import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { useRefereeRoleListQuery } from '../queries';
import { ForwardedRef, forwardRef } from 'react';
import { HasStyle } from '~/types/HasStyle';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & HasStyle;

function RefereeRoleSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useRefereeRoleListQuery();

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Alla domarroller'}
      options={data.map(o => [o.description, o.name])}
      disabled={isLoading}
      ref={ref}
      {...props}
    />
  );
}

export const RefereeRoleSelect = forwardRef(RefereeRoleSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof RefereeRoleSelectElement>;
